export var HotelBookType;
(function (HotelBookType) {
    HotelBookType["DEFAULT"] = "default";
})(HotelBookType || (HotelBookType = {}));
export var HOTEL_BOOK_TYPE = "hotelBookType";
export var CFAR_OFFER_TYPE = "cfarOfferType";
//# sourceMappingURL=constants.js.map